import { FormBase } from 'core/components';

export default class InsuranceOrderingEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'id',
                    label: 'INSURANCE_ORDERING.CREATE.INSURANCE_LABEL',
                    placeholder: 'INSURANCE_ORDERING.CREATE.INSURANCE_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'primarySort',
                    label: 'INSURANCE_ORDERING.CREATE.PRIMARY_SORT_LABEL',
                    placeholder: 'INSURANCE_ORDERING.CREATE.PRIMARY_SORT_LABEL',
                    rules: ['min:1'],
                    type: 'integer'
                },
                {
                    name: 'secondarySort',
                    label: 'INSURANCE_ORDERING.CREATE.SECONDARY_SORT_LABEL',
                    placeholder: 'INSURANCE_ORDERING.CREATE.SECONDARY_SORT_LABEL',
                    rules: ['min:1'],
                    type: 'integer'
                },
            ],
        };
    }
}
